var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapMarkerAlt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.149,
    height: 43.532,
    viewBox: "0 0 33.149 43.532",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .a {\n        fill:#3fabff;\n        stroke:#fff;\n        stroke-width:2px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.974,40.694C2.188,23.608,0,21.854,0,15.575a15.575,15.575,0,0,1,31.149,0c0,6.28-2.188,8.033-13.974,25.12a1.948,1.948,0,0,1-3.2,0Zm1.6-18.63a6.489,6.489,0,1,0-6.489-6.489A6.489,6.489,0,0,0,15.575,22.064Z",
    transform: "translate(1 1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarkerAlt);
export default __webpack_public_path__ + "static/media/map-marker-alt.cb65c1a19b4b903c835bd32ab2d3c6ee.svg";
export { ForwardRef as ReactComponent };